import React, { useEffect, useState } from 'react';
import { jssor_1_slider_init } from '../../common/cores';
import { connect } from 'react-redux';

const MobileVisual = (props) => {

  const {isAuthenticated} = props.user;

  const [style, setStyle] = useState({});

  const handleResize = () => {
    if (window.innerWidth <= 800) {
      setStyle({
        display: 'block',
        marginTop: isAuthenticated ? '90px' : '140px',
      });
    } else {
      setStyle({
        display: '',
        marginTop: '',
      });
    }
  };

  useEffect(() => {
    handleResize(); // 초기 화면 크기 확인
    window.addEventListener('resize', handleResize); // 리사이즈 이벤트 리스너 추가

    return () => {
      window.removeEventListener('resize', handleResize); // 리스너 제거
    };
  }, []);

  useEffect(() => {
    if(window.innerWidth <= 800){
      if(isAuthenticated){
        setStyle({
          display: 'block',
          marginTop: '90px',
        });
      }
      else{
        setStyle({
          display: 'block',
          marginTop: '140px',
        });
      }
    }
  }, [isAuthenticated])

  return (
    <div id="demo" className="carousel slide" data-ride="carousel" style={style}>

      <ul className="carousel-indicators">
        <li data-target="#demo" data-slide-to="0" className="active"></li>
        <li data-target="#demo" data-slide-to="1"></li>
        <li data-target="#demo" data-slide-to="2"></li>
      </ul>

      <div className="carousel-inner">
        <div className="carousel-item active">
          <img src="../images/m_slideshow1.jpg" alt="Los Angeles" style={{width: "100%"}} alt="" />
        </div>
        <div className="carousel-item">
          <img src="../images/m_slideshow2.jpg" alt="Chicago" style={{width: "100%"}} alt="" />
        </div>
        <div className="carousel-item">
          <img src="../images/m_slideshow3.jpg" alt="New York" style={{width: "100%"}} alt="" />
        </div>
      </div>

      <a className="carousel-control-prev" href="#demo" data-slide="prev">
        <span className="carousel-control-prev-icon"></span>
      </a>
      <a className="carousel-control-next" href="#demo" data-slide="next">
        <span className="carousel-control-next-icon"></span>
      </a>
    </div>
  );
};

const mapStateToProps = state => ({
  user : state.user
})

export default connect(mapStateToProps)(MobileVisual);


// WEBPACK FOOTER //
// ./src/components/common/MobileVisaul.js